import {Text, VStack} from 'platform/foundation';

import {ReactNode} from 'react';

import {TestIdProps} from 'shared/web';

type CustomerSatisfactionCellProps = TestIdProps & {
  label: string;
  'aria-label'?: string;
  children: ReactNode;
};

export function CustomerSatisfactionCell(props: CustomerSatisfactionCellProps) {
  return (
    <section data-testid={props['data-testid']} aria-label={props['aria-label'] ?? props.label}>
      <VStack spacing={1}>
        <Text size="xSmall" color="secondary">
          {props.label}
        </Text>
        {props.children}
      </VStack>
    </section>
  );
}
